import { http } from "./http";

export type Shipper = {
    id: string;
    name: string;
    trackingNumber: string | null;
    trackingOrderUrl: string | null;
};

export type TrackingOrderLine = {
    id: string;
    lineNumber: number;
    quantity: number;
    partNumber: string;
    description: string;
    orderDate: string;
    estimatedShipDate: string | null;
    shipper: Shipper | null;
};

export type TrackingOrder = {
    purchaseOrderNumber: string;
    manufacturer: { name: string };
    trackingOrderLines: TrackingOrderLine[];
    shipments: Shipper[];
};

export const ordersApi = {
    async search(text: string): Promise<TrackingOrder[]> {
        const { data } = await http.post<TrackingOrder[]>("/api/v0/orders/tracking/search", { text });
        return data;
    },
    async vendor(slug: string, purchaseOrderNumber: string): Promise<TrackingOrder[]> {
        const { data } = await http.post<TrackingOrder[]>("/api/v0/orders/tracking/vendor", { key: slug, purchaseOrderNumber });
        return data;
    },
};
